module.exports = __webpack_public_path__ + "static/img/1.6513d2d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/12/zh/1.png
// module id = YChV
// module chunks = 0